import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tasksApi } from '../api';

// Cuadros de trabajo / workframe (integración main→dev, epic D1). La lista de tareas de la
// bitácora cuelga de `['tasks','list', …]` a propósito: el socket `task_*` que `ComponentTaskHoy`
// ya escucha invalida `['tasks','list']` como prefijo → la bitácora se refresca sin un
// handler paralelo (lección de D2).

export function useWorkframeList(spaceId) {
    return useQuery({
        queryKey: ['tasks', 'workframes', spaceId ?? 'all'],
        queryFn: async () => {
            const data = await tasksApi.fetchWorkframes(spaceId);
            return data.success && Array.isArray(data.workframes) ? data.workframes : [];
        },
        refetchOnWindowFocus: false,
    });
}

export function useWorkframe(id) {
    return useQuery({
        queryKey: ['tasks', 'workframe', id],
        queryFn: async () => {
            const data = await tasksApi.fetchWorkframeById(id);
            return data.success ? data.workframe : null;
        },
        enabled: !!id,
        refetchOnWindowFocus: false,
    });
}

export function useWorkframeTasks(workframeId, docId) {
    return useQuery({
        queryKey: ['tasks', 'list', 'workframe', workframeId, docId ?? null],
        queryFn: async () => {
            const data = await tasksApi.fetchWorkframeTasks(workframeId, docId);
            return data.success && Array.isArray(data.tasks) ? data.tasks : [];
        },
        enabled: !!workframeId,
        refetchOnWindowFocus: false,
    });
}

export function useCreateWorkframe(spaceId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (payload) => tasksApi.createWorkframe(payload),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['tasks', 'workframes', spaceId ?? 'all'] }),
    });
}

export function useUpdateWorkframe(spaceId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, payload }) => tasksApi.updateWorkframe(id, payload),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['tasks', 'workframes', spaceId ?? 'all'] }),
    });
}
